import React from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { HOME_ROUTE } from '../../../../constants/routes';

const ProtectedRoute = ({ children, isLoggedIn }) => {
  if (isLoggedIn) {
    return children;
  }
  return <Navigate to={HOME_ROUTE} replace />;
};

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
  isLoggedIn: PropTypes.bool,
};

ProtectedRoute.defaultProps = {
  isLoggedIn: false,
};

export default ProtectedRoute;
